import React from "react";
import { Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import AccountInfo from "../components/Common/AccountInfo/AccountInfo";
import infoIcon from "../assets/icons/header/identification 1.png";

const AccountPage = () => {
  const navigate = useNavigate();
  const handleTabChange = (key) => {
    navigate(`/account/${key}`);
  };

  const tabItems = [
    { key: "1", label: "Thông tin tài khoản", icon: infoIcon },
  ];

  const activeTab = "1";

  return (
    <div className="p-6 flex justify-center space-x-4 lg:min-h-[640px] overflow-y-auto pt-32">
      <div className="sm:max-w-[28%] xs:max-w-[30%] sm:pt-2 max-w-[20%] h-[240px] bg-[#242333] rounded-lg">
        <Tabs
          tabPosition="left"
          activeKey={activeTab}
          onChange={handleTabChange}
          className="custom-tabs"
          items={tabItems.map((item, index) => ({
            key: item.key,
            label: (
              <span
                className={`tab-item font-semibold min-w-56 py-4 flex items-center text-white ${
                  activeTab === item.key ? "opacity-100" : "opacity-70"
                } hover:opacity-100 text-base p-2 ${
                  index < tabItems.length - 1 ? "border-b border-gray-600" : ""
                }`}
              >
                <img src={item.icon} alt="" className="h-8 w-8 mr-2" />
                {item.label}
              </span>
            ),
          }))}
        />
      </div>
      <div className="xs:w-[50%] md:w-[60%] sm:w-[65%] lg:w-[965px] h-full bg-[#242333] px-4 pt-4 pb-8 rounded-lg">
        <AccountInfo />
      </div>
    </div>
  );
};

export default AccountPage;
